import { render, staticRenderFns } from "./VueDraggableResizable.vue?vue&type=template&id=5029ae90"
import script from "./VueDraggableResizable.vue?vue&type=script&lang=js"
export * from "./VueDraggableResizable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5029ae90')) {
      api.createRecord('5029ae90', component.options)
    } else {
      api.reload('5029ae90', component.options)
    }
    module.hot.accept("./VueDraggableResizable.vue?vue&type=template&id=5029ae90", function () {
      api.rerender('5029ae90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/VueDraggableResizable.vue"
export default component.exports